var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"lesson-text-field mt-6 mx-1",attrs:{"dense":"","outlined":"","value":!!_vm.value}},[_c('div',{staticClass:"lesson-text-field-label"},[_vm._v(_vm._s(_vm.label))]),_c('pre',{staticClass:"lesson-text-field-value",domProps:{"textContent":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }